import { useCallback, useState } from "react";
import { DialogContext } from "@/lib/dialogs";
import { Header } from "@/components/portal/Header";
import { Hero, IntroStrip } from "@/components/portal/Hero";
import { Audience } from "@/components/portal/Audience";
import { Workflow } from "@/components/portal/Workflow";
import { SarvamBand } from "@/components/portal/SarvamBand";
import { BottomGrid, FinalCta, Footer } from "@/components/portal/BottomSections";
import { OnboardingWizard } from "@/components/portal/onboarding/OnboardingWizard";
import { InquiryDialog } from "@/components/portal/InquiryDialog";
import { PartnerDialog } from "@/components/portal/PartnerDialog";
import { LauncherDialog } from "@/components/portal/LauncherDialog";
import { ConnectionDialog } from "@/components/portal/ConnectionDialog";

const DIALOGS = { onboard: OnboardingWizard, inquiry: InquiryDialog, partner: PartnerDialog, launcher: LauncherDialog, connect: ConnectionDialog };

export default function Portal() {
  const [dialog, setDialog] = useState(null);
  const open = useCallback((kind, props = {}) => setDialog({ kind, props, id: Date.now() }), []);
  const Active = dialog ? DIALOGS[dialog.kind] : null;

  return (
    <DialogContext.Provider value={open}>
      <div className="page" data-testid="ayndri-portal">
        <Header />
        <main id="top">
          <Hero />
          <IntroStrip />
          <div className="content">
            <Audience />
            <Workflow />
            <SarvamBand />
            <BottomGrid />
            <FinalCta />
          </div>
        </main>
        <Footer />
      </div>
      {Active && <Active key={dialog.id} {...dialog.props} onClose={() => setDialog(null)} />}
    </DialogContext.Provider>
  );
}
